<template>
    <div class="vuetify-style" style="background: transparent">
        <v-color-picker :key="name" v-model="color" style="height: 5rem" dot-size="50" hide-canvas hide-mode-switch
                        mode="hexa"></v-color-picker>
        <input type="hidden" :name="name" v-model="color"/>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        value: String
    },
    data: () => ({
        color: '#FF00FF',
    }),
    mounted()
    {
        this.color = this.value;
    }
}
</script>

<style scoped>
.vuetify-style:deep(.v-application--wrap) {
    min-height: auto;
}

.vuetify-style:deep(.v-color-picker__input) {
    opacity: 0;
}

.vuetify-style:deep(.v-color-picker) {
    max-width: 100% !important;
    width: 100%;
    height: 4rem !important;
    background: white;
    border-radius: 9999px;
    border: 1px solid #E6E6E6;
}

.vuetify-style:deep(.v-color-picker__preview .v-slider) {
    min-height: 20px !important;
}

.vuetify-style:deep(.v-color-picker__edit) {
    display: none;
}

.vuetify-style:deep(.v-color-picker__sliders .v-input__slider:nth-child(1)) {
    margin-bottom: 0;
}

.vuetify-style:deep(.v-color-picker__sliders .v-input__slider:nth-child(2)) {
    display: none;
}
</style>
